import React, { useContext, useState, useEffect } from 'react';
import FilterButton from './FilterButton';
import { EventMapContext } from '../context/EventMapContext';

const MobileCheckboxDropdownSection = ({
  data,
  title,
  formStyles,
  className,
}) => {
  const { setCurrentMenu, setVariables, variables } = useContext(
    EventMapContext
  );

  const [localCategories, setLocalCategories] = useState([]);

  const [clicked, setClicked] = useState([false]);

  useEffect(() => {
    setLocalCategories(variables.category_in);
  }, [variables.category_in]);

  return (
    <div style={{ width: '100%' }}>
      <div className="checkbox-container-header">
        <div style={{ margin: '0 auto', paddingLeft: '10%' }}>{title}</div>
        <button
          aria-label="Clear Categories Filter"
          name="Clear Categories Filter"
          onClick={() => setLocalCategories([])}
          className="clear-btn clear-btn-mobile"
          type="button"
          style={{ position: 'relative', left: '120px' }}
        >
          Clear
        </button>
      </div>
      <form
        className={`form ${className}`}
        style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(2, 1fr)',
          marginTop: '24px',
          color: '#C4C4C4',
          ...formStyles,
        }}
      >
        {data.map(item => (
          <label
            key={item.value}
            htmlFor={`category-type-${item.value}-mobile`}
          >
            <input
              aria-label={`${item.title}`}
              id={`category-type-${item.value}-mobile`}
              type="checkbox"
              className="category-checkbox-mobile"
              checked={localCategories.includes(
                item.title.replace(/\s/g, '_').toLowerCase()
              )}
              onChange={e => {
                e.stopPropagation();
                if (
                  localCategories.includes(
                    item.title.replace(/\s/g, '_').toLowerCase()
                  )
                ) {
                  setLocalCategories(
                    localCategories.filter(
                      localCategory =>
                        localCategory.replace(/\s/g, '_').toLowerCase() !==
                        item.title.replace(/\s/g, '_').toLowerCase()
                    )
                  );
                } else {
                  setLocalCategories([
                    ...localCategories,
                    item.title.replace(/\s/g, '_').toLowerCase(),
                  ]);
                }
              }}
            />
            <p>{item.title}</p>
          </label>
        ))}
      </form>
      <div className="btn-container">
        <FilterButton
          onClick={e => {
            e.stopPropagation();
            setVariables({
              ...variables,
              category_in: localCategories.map(category =>
                category.replace(/\s/g, '_')
              ),
            });
            setCurrentMenu('');
            setClicked(!clicked);
          }}
          className="apply-btn"
        >
          Apply
        </FilterButton>
        <button
          aria-label="Clear Category Filters"
          name="Clear Category Filters"
          type="button"
          className="btn btn--light btn--small"
          style={{
            border: 'none',
            textDecoration: 'underline',
          }}
          onClick={() => {
            setLocalCategories([]);
            setVariables({
              ...variables,
              category_in: [],
            });
          }}
        >
          Clear
        </button>
      </div>
    </div>
  );
};

export default MobileCheckboxDropdownSection;
